import React from 'react';
import { IconBase } from '../Base';
export const IconCOP = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("g", { clipPath: "url(#clip0_2_7798)" },
        React.createElement("path", { d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12L12 13.0435L0 12Z", fill: "#FFDA44" }),
        React.createElement("path", { d: "M1.60577 18C3.6807 21.5867 7.55838 24 12 24C16.4417 24 20.3193 21.5867 22.3943 18L12 17.2174L1.60577 18Z", fill: "#D80027" }),
        React.createElement("path", { d: "M22.3942 18C23.4153 16.235 24 14.1858 24 12H0C0 14.1858 0.584719 16.235 1.60575 18H22.3942Z", fill: "#0052B4" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_7798" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=COP.js.map